type Props = {
  children: JSX.Element;
};

export const TabContent: React.FC<Props> = (props: Props): JSX.Element => {
  return props.children;
};
